import * as guards from '../../../../utils/guards';
import { filterNotEmpty } from '../../../../utils/listHelpers';

/**
 * Removes empty values from an object recursively
 * @param queryModel
 */
export function sanitizeObject(queryModel: Record<string, any>): Record<string, any> {
  return Object.entries(queryModel).reduce<Record<string, any>>((acc, [key, value]) => {
    if (!guards.isObject(value) || guards.isDate(value)) {
      if (!isEmpty(value)) {
        if (guards.isArray(value)) {
          const values = filterNotEmpty(value, { removeEmptyArrays: true, removeEmptyStrings: true });
          return !!values.length ? { ...acc, [key]: values } : acc;
        }
        return {
          ...acc,
          [key]: value
        };
      } else {
        return acc;
      }
    } else {
      const child = sanitizeObject(value);
      return !isEmpty(child)
        ? {
            ...acc,
            [key]: child
          }
        : acc;
    }
  }, {});
}

export function isEmpty(value: unknown): boolean {
  if (guards.isUndefined(value)) return true;
  if (guards.isNull(value)) return true;
  if (guards.isString(value)) {
    return value === '';
  }
  if (guards.isArray(value)) {
    return value.length === 0;
  }
  if (guards.isDate(value)) {
    return false;
  }
  if (guards.isObject(value)) {
    return Object.keys(value).length === 0;
  }
  if (guards.isBoolean(value)) {
    return false;
  }
  if (guards.isNumber(value)) {
    return false;
  }
  return !!guards.isFunction(value);
}
